import {
	getChongzhiRule,
	addChongzhiRule,
	editChongzhiRule,
	delChongzhiRule,
	getInterval,
	addInterval,
	editInterval,
	delInterval,
	getPayType,
	addHongbao,
	getHongbao,
	editHongbao,
	faHongbao,
	getHongbaoList,
	editCancelRule,
	addCancelRule,
	delCancelRule,
	getCancelRule,
	delEatingRules,
	getType,
	delHongbao,
	getMachine,
	editMachine,
	delMachine,
	addMachine
} from '@/api/marketing'
const state = {}
const mutations = {}

const actions = {
	delMachine ({}, data) {
		return new Promise((resolve, reject) => {
			delMachine(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editMachine ({}, data) {
		return new Promise((resolve, reject) => {
			editMachine(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addMachine ({}, data) {
		return new Promise((resolve, reject) => {
			addMachine(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMachine ({}, data) {
		return new Promise((resolve, reject) => {
			getMachine(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delEatingRules ({}, data) {
		return new Promise((resolve, reject) => {
			delEatingRules(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getType ({}, data) {
		return new Promise((resolve, reject) => {
			getType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editCancelRule ({}, data) {
		return new Promise((resolve, reject) => {
			editCancelRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addCancelRule ({}, data) {
		return new Promise((resolve, reject) => {
			addCancelRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCancelRule ({}, data) {
		return new Promise((resolve, reject) => {
			delCancelRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCancelRule ({}, data) {
		return new Promise((resolve, reject) => {
			getCancelRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getHongbaoList ({}, data) {
		return new Promise((resolve, reject) => {
			getHongbaoList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addHongbao ({}, data) {
		return new Promise((resolve, reject) => {
			addHongbao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getHongbao ({}, data) {
		return new Promise((resolve, reject) => {
			getHongbao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editHongbao ({}, data) {
		return new Promise((resolve, reject) => {
			editHongbao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	faHongbao ({}, data) {
		return new Promise((resolve, reject) => {
			faHongbao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getPayType ({}, data) {
		return new Promise((resolve, reject) => {
			getPayType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getChongzhiRule ({}, data) {
		return new Promise((resolve, reject) => {
			getChongzhiRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addChongzhiRule ({}, data) {
		return new Promise((resolve, reject) => {
			addChongzhiRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delChongzhiRule ({}, data) {
		return new Promise((resolve, reject) => {
			delChongzhiRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editChongzhiRule ({}, data) {
		return new Promise((resolve, reject) => {
			editChongzhiRule(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getInterval ({}, data) {
		return new Promise((resolve, reject) => {
			getInterval(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editInterval ({}, data) {
		return new Promise((resolve, reject) => {
			editInterval(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addInterval ({}, data) {
		return new Promise((resolve, reject) => {
			addInterval(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delInterval ({}, data) {
		return new Promise((resolve, reject) => {
			delInterval(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delHongbao ({}, data) {
		return new Promise((resolve, reject) => {
			delHongbao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
